import React from "react"
import { Box, Skeleton, Card, CardContent, Grid } from "@mui/material"

interface LoadingSkeletonProps {
  type?: "dashboard" | "table" | "chart" | "card"
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  type = "dashboard",
}) => {
  if (type === "dashboard") {
    return (
      <Box>
        {/* Header skeleton */}
        <Box sx={{ mb: 4 }}>
          <Skeleton variant="text" width="40%" height={60} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="60%" height={32} />
        </Box>

        {/* Metrics cards skeleton */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {[1, 2, 3, 4].map((item) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={item}>
              <Card
                sx={{
                  background:
                    "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  border: "1px solid rgba(26, 35, 126, 0.1)",
                  borderRadius: 3,
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Skeleton
                        variant="text"
                        width="70%"
                        height={20}
                        sx={{ mb: 1 }}
                      />
                      <Skeleton variant="text" width="50%" height={40} />
                    </Box>
                    <Skeleton variant="circular" width={60} height={60} />
                  </Box>
                  <Skeleton
                    variant="rectangular"
                    width="60%"
                    height={24}
                    sx={{ borderRadius: 1 }}
                  />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Charts skeleton */}
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 8 }}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                border: "1px solid rgba(26, 35, 126, 0.1)",
                borderRadius: 3,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Skeleton
                  variant="text"
                  width="30%"
                  height={32}
                  sx={{ mb: 2 }}
                />
                <Skeleton
                  variant="rectangular"
                  height={300}
                  sx={{ borderRadius: 2 }}
                />
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                border: "1px solid rgba(26, 35, 126, 0.1)",
                borderRadius: 3,
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Skeleton
                  variant="text"
                  width="40%"
                  height={32}
                  sx={{ mb: 2 }}
                />
                <Skeleton
                  variant="circular"
                  width={200}
                  height={200}
                  sx={{ mx: "auto" }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    )
  }

  if (type === "table") {
    return (
      <Card
        sx={{
          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
          border: "1px solid rgba(26, 35, 126, 0.1)",
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 0 }}>
          <Box sx={{ p: 2 }}>
            <Skeleton variant="text" width="30%" height={32} sx={{ mb: 2 }} />
            <Skeleton
              variant="rectangular"
              height={400}
              sx={{ borderRadius: 2 }}
            />
          </Box>
        </CardContent>
      </Card>
    )
  }

  if (type === "chart") {
    return (
      <Card
        sx={{
          background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
          border: "1px solid rgba(26, 35, 126, 0.1)",
          borderRadius: 3,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
          <Skeleton
            variant="rectangular"
            height={300}
            sx={{ borderRadius: 2 }}
          />
        </CardContent>
      </Card>
    )
  }

  return (
    <Card
      sx={{
        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
        border: "1px solid rgba(26, 35, 126, 0.1)",
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Skeleton variant="text" width="60%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="rectangular" height={100} sx={{ borderRadius: 2 }} />
      </CardContent>
    </Card>
  )
}

export default LoadingSkeleton
